import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDSelectBox from "components/MDSelectBox";
import { useFormik } from "formik";
import { ModalContext } from "context/ModalContext";
import PropTypes from "prop-types";
import { LoginFormContext } from "context/LoginFormContext";
import { eventAdd } from "Apis/event";
import { updateEvent } from "Apis/event";
import ImageUploader from "components/MDImageUploader";
import MDDatePicker from "components/MDDatepicker";
import MDTimePicker from "components/MDTimepicker";
import moment from "moment";
import { EventContext } from "context/EventContext";
import { AuthRouteJson } from "helpers/constant";
import { initialValues, updateInitialValues } from "./schemas/initialValue";
import { validationSchema } from "./schemas/validation";
import dayjs from "dayjs";
import MDGoogleMap from "components/MDGoogleMap";
import { statusData } from "helpers/constant";
import MDTextField from "components/MDTextField";
import Iconify from "components/Iconify";
import SubmitButton from "components/SubmitButton";
import DraggableLinkForm from "../eventDragList";
import SingleCheckbox from "components/MDCheckBox/MDSingleCheckBox";
import { fetchQrTemplateListApi } from "Apis/qrTemplate";
import { InputAdornment, Typography } from "@mui/material";

export let popularData = [
  {
    label: "Popular",
    value: "1",
  },
  {
    label: "Not Popular",
    value: "0",
  },
];

const EventForm = ({ getEventList }) => {
  const { editData, advertisementData, advertisementAllList } = useContext(EventContext);
  const { setNotification, profileImage, setProfileImage } = useContext(LoginFormContext);
  const [status, setStatus] = useState({
    label: "Inactive",
    value: "0",
  });
  const { setOpen, formIsEdit } = useContext(ModalContext);
  const [popular, setPopular] = useState("Not Popular");
  const [startDate, setStartDate] = useState("");
  const [selectedPosition, setSelectedPosition] = useState();
  const [advertisement, setAdvertisement] = useState([]);
  const [template, setTemplate] = useState([]);
  const [memberOnly, setMemberOnly] = useState(false);
  const [isAllowGuest, setIsAllowGuest] = useState(false);
  const [isHideBooking, setIsHideBooking] = useState(false);
  const [isBookOnline, setIsBookOnline] = useState(false);
  const [tempList, setTempList] = useState([]);
  // setData in Formik...
  const setDataInFormik = async () => {
    formik.setValues(editData);
    formik.setFieldValue("event_registration_link", editData?.event_registration_links);
    formik.setFieldValue("member_price", editData?.event_prices[0]?.member_price || 0);
    formik.setFieldValue("booking_amount", editData?.booking_amount || 0);
    formik.setFieldValue("special_price", editData?.event_prices[0]?.special_price || 0);
    formik.setFieldValue("member_only", editData?.member_only === 1 ? true : false);
    formik.setFieldValue("event_images", editData?.event_images[0]?.image.split("/").pop());
    const adIds = editData?.event_advertisements?.map((ad) => ad.advertisement_id);
    formik.setFieldValue("event_advertisements", adIds);
    setMemberOnly(editData?.member_only === 1 ? true : false);
    setIsHideBooking(editData?.is_hide_total_bookings === 1 ? true : false);
    setIsAllowGuest(editData?.is_allow_guest_booking === 1 ? true : false);
    setIsBookOnline(editData?.is_online_booking_available === 1 ? true : false);
    setAdvertisement(
      editData?.event_advertisements?.map((data) => ({
        value: data.advertisement.id,
        label: data.advertisement.title,
      }))
    );
    setProfileImage({
      url: editData?.event_images[0]?.image || null,
      name: null,
    });
  };

  const getPopularLabel = (val) => {
    const popular = popularData.find((item) => item?.value == val);
    return popular ? popular.label : "-";
  };
  const getTemplateLabel = (val) => {
    const temp = tempList.find((item) => item?.value == val);
    return temp ? temp.label : "";
  };

  const getStatusLabel = (id) => {
    const status = statusData.find((item) => item.value == id);
    return status ? status.label : "-";
  };

  const handleAdvertisement = (val) => {
    const selectedValues = val?.map((data) => data?.value);
    setAdvertisement(val?.map((option) => ({ value: option?.value, label: option?.label })));
    formik.setFieldValue("event_advertisements", selectedValues);
  };
  const getTempList = async () => {
    let response = await fetchQrTemplateListApi();
    const templateOptions = response?.data?.data?.rows?.map((t) => ({
      label: t?.title,
      value: t?.id,
      imageUrl: t?.qr_templates_images?.image,
    }));
    setTempList(templateOptions);
  };
  useEffect(() => {
    advertisementAllList();
    getTempList();
    if (formIsEdit) {
      setDataInFormik();
      setPopular({ label: getPopularLabel(editData?.is_popular), value: editData?.is_popular });
      setStatus({ label: getStatusLabel(editData?.is_active), value: editData?.is_active });
      const lat = editData?.latitude;
      const lng = editData?.longitude;
      setSelectedPosition({ lat, lng });
    } else if (formIsEdit === false) {
      setProfileImage({
        url: null,
        name: null,
      });
    }
  }, []);
  useEffect(() => {
    if (formIsEdit && tempList.length > 0) {
      setTemplate({ label: getTemplateLabel(editData?.template_id), value: editData?.template_id });
    }
  }, [tempList]);

  //HandleSubmit Form
  const handleSubmit = async (values) => {
    // const formattedValues = {
    //   ...values,
    //   event_images: profileImage.name
    //     ? [profileImage.name]
    //     : formIsEdit && editData
    //       ? [editData?.event_images[0]?.image.split("/").pop()]
    //       : [],
    // };
    const payload = {
      ...values,
      end_date: values.end_date === "" ? null : values.end_date,
      guest_limit_for_booking: Number(values.guest_limit_for_booking || 0),
      guest_price: Number(values.guest_price || 0),
    };

    if (!formIsEdit) {
      let response = await eventAdd(payload);
      if (response?.status === 200) {
        getEventList();
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
      }
    } else {
      let response = await updateEvent(payload);
      if (response?.status === 200) {
        getEventList();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
        setOpen(false);
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response?.data?.message,
          open: true,
        });
      }
    }
  };

  const handleStatusChange = (value) => {
    if (value) {
      formik.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  const handleStartDate = (date, fieldName) => {
    if (date) {
      let dateFormat = moment(new Date(date)).format("YYYY-MM-DD");
      formik.setFieldValue("start_date", dateFormat);
      setStartDate(dateFormat);
      formik.setFieldValue("end_date", "");
    } else {
      formik.setFieldValue(fieldName, null);
    }
  };

  const handleEndDate = (date, fieldName) => {
    if (date) {
      let dateFormat = moment(new Date(date)).format("YYYY-MM-DD");
      formik.setFieldValue("end_date", dateFormat);
    } else {
      formik.setFieldValue(fieldName, null);
    }
  };

  const handleStartTime = (time, fieldName) => {
    if (time) {
      formik.setFieldValue("start_time", time);
    } else {
      formik.setFieldValue(fieldName, null);
    }
  };

  const handleEndTime = (time, fieldName) => {
    if (time) {
      formik.setFieldValue("end_time", time);
    } else {
      formik.setFieldValue(fieldName, null);
    }
  };

  const hasPopular = (value) => {
    if (value) {
      formik.setFieldValue("is_popular", value.value);
      setPopular(value);
    } else {
      formik.setFieldValue("is_popular", null);
      setPopular(null);
    }
  };

  const handleTemp = (value) => {
    if (value) {
      formik.setFieldValue("template_id", value.value);
      setTemplate(value);
    } else {
      formik.setFieldValue("template_id", null);
      setTemplate(null);
    }
  };
  const handleIsMemberOnly = (e) => {
    const checked = e?.target?.checked;
    setMemberOnly(checked);
    formik.setFieldValue("member_only", checked ? 1 : 0);
    if (!checked) {
      setIsAllowGuest(false);
      formik.setFieldValue("is_allow_guest_booking", 0);
      formik.setFieldValue("guest_limit_for_booking", 0);
      formik.setFieldValue("guest_price", 0);
    }
  };
  const handleIsAllowGuestBooking = (e) => {
    const checked = e?.target?.checked;
    setIsAllowGuest(checked);
    formik.setFieldValue("is_allow_guest_booking", checked ? 1 : 0);
    if (!checked) {
      formik.setFieldValue("guest_limit_for_booking", 0);
      formik.setFieldValue("guest_price", 0);
    }
  };
  const handleTotalBooking = (e) => {
    setIsHideBooking(e?.target?.checked);
    formik.setFieldValue("is_hide_total_bookings", e?.target?.checked ? 1 : 0);
  };
  const handleIsOnlineBook = (e) => {
    setIsBookOnline(e?.target?.checked);
    formik.setFieldValue("is_online_booking_available", e?.target?.checked ? 1 : 0);
  };

  const handleAddRegistrationLink = () => {
    const currentLinks = formik?.values?.event_registration_link;
    const newDisplayOrder = currentLinks?.length + 1;

    const newRegistrationLink = [
      ...currentLinks,
      { title: "", link: "", button_title: "", is_show: 1, display_order: newDisplayOrder },
    ];
    formik.setFieldValue("event_registration_link", newRegistrationLink);
  };

  const handleRegistrationTitleChange = (index, value) => {
    formik.setFieldValue(`event_registration_link[${index}].title`, value);
  };

  const handleRegistrationLinkChange = (index, value) => {
    formik.setFieldValue(`event_registration_link[${index}].link`, value);
  };

  const handleButtonTextChange = (index, value) => {
    formik.setFieldValue(`event_registration_link[${index}].button_title`, value);
  };

  const handleRemoveRegistration = (index) => {
    const newRegistrationLink = formik.values.event_registration_link.filter((_, i) => i !== index);
    formik.setFieldValue("event_registration_link", newRegistrationLink);
  };

  const handleReorder = (sourceIndex, destinationIndex, formik) => {
    const items = [...formik.values.event_registration_link];
    const [movedItem] = items.splice(sourceIndex, 1);
    items.splice(destinationIndex, 0, movedItem);

    const updatedItems = items.map((item, index) => ({
      ...item,
      display_order: index + 1,
    }));

    formik.setFieldValue("event_registration_link", updatedItems);
  };
  //Formik
  const formik = useFormik({
    initialValues: !formIsEdit ? initialValues : updateInitialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  console.log("formik", formik);
  return (
    <>
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {/* Image */}
          <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
            <ImageUploader
              img={profileImage.url}
              folderName="events"
              fileName={"event_images"}
              name={"event_images"}
              formik={formik}
              label="Event Image"
              sx={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "50%",
                marginBottom: "16px",
              }}
              required
            />
            {formik.touched.event_images && formik.errors.event_images && (
              <MDBox
                component="p"
                sx={{
                  fontSize: "12px",
                  marginLeft: "5px",
                  color: "red",
                }}
              >
                {formik.errors.event_images}
              </MDBox>
            )}
          </Grid>

          {/* Title*/}
          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="title"
              value={formik.values.title}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Title"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.title && formik.errors.title && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.title}
              </MDBox>
            )}
          </Grid>

          {/* Sub Title */}
          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="sub_title"
              value={formik.values.sub_title}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Sub Title"
              variant="standard"
            />
          </Grid>

          {/* Description */}
          <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Description"
              sx={{ width: "100%" }}
              variant="standard"
              required
              rows={4}
              multiline
            />
            {formik.touched.description && formik.errors.description && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.description}
              </MDBox>
            )}
          </Grid>

          {/* Start Date */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
            <MDBox mb={2} className="date__picker">
              <MDDatePicker
                width="100% !important"
                name="start_date"
                value={formik.values.start_date}
                onChange={(date) => handleStartDate(date, "start_date")}
                onBlur={formik.handleBlur}
                label="Start Date"
                disablePast={false}
                required
              />
              {formik.touched.start_date && formik.errors.start_date && (
                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {formik.errors.start_date}
                </MDBox>
              )}
            </MDBox>
          </Grid>

          {/* End Date */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
            <MDBox mb={2} className="date__picker">
              <MDDatePicker
                width="100% !important"
                name="end_date"
                value={formik.values.end_date}
                onChange={(date) => handleEndDate(date, "end_date")}
                onBlur={formik.handleBlur}
                label="End Date"
                minDate={dayjs(startDate)}
                disablePast={false}
              />
              {formik.touched.end_date && formik.errors.end_date && (
                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {formik.errors.end_date}
                </MDBox>
              )}
            </MDBox>
          </Grid>

          {/* Start Time */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "10px !important" }}>
            <MDTimePicker
              width="100% !important"
              name="start_time"
              value={formik?.values?.start_time}
              onChange={(time) => handleStartTime(time, "start_time")}
              onBlur={formik.handleBlur}
              label="Start Time"
              required
            />
            {formik.touched.start_time && formik.errors.start_time && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.start_time}
              </MDBox>
            )}
          </Grid>

          {/* End Time */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "10px !important" }}>
            <MDTimePicker
              width="100% !important"
              name="end_time"
              value={formik?.values?.end_time}
              onChange={(time) => handleEndTime(time, "end_time")}
              onBlur={formik.handleBlur}
              label="End Time"
            />
            {formik.touched.end_time && formik.errors.end_time && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.end_time}
              </MDBox>
            )}
          </Grid>

          {/* Location */}
          <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
            <MDTextField
              type="text"
              name="location"
              value={formik.values.location}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Location"
              sx={{ width: "100%" }}
              variant="standard"
              required
              multiline
              rows={4}
            />
            {formik.touched.location && formik.errors.location && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.location}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={12} sx={{ paddingTop: "50px !important" }}>
            <MDSelectBox
              name="template_id"
              defaultValue={template}
              options={tempList}
              handleChange={(value) => handleTemp(value)}
              label="Template"
              width="100%"
              isImage
              imgHeight={50}
              imgWidth={50}
              squareImage
              required={isBookOnline}
              multiple={false}
              onBlur={formik.handleBlur}
            />
            {formik.errors.template_id && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.template_id}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={12} sx={{ paddingTop: "30px !important", position: "relative" }}>
            <MDGoogleMap
              selectedPosition={{ lat: formik.values.latitude, lng: formik.values.longitude }}
              formik={formik}
              formikKeyName="location"
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="max_attendees"
              value={formik.values.max_attendees || 0}
              onChange={(e) => {
                const value = e.target.value === "" ? 0 : Number(e.target.value);
                if (/^\d*$/.test(value)) {
                  formik.setFieldValue("max_attendees", value);
                }
              }}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Max Attendance "
              variant="standard"
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="booking_amount"
              value={formik.values.booking_amount}
              onChange={(e) => {
                const value = e.target.value === "" ? 0 : Number(e.target.value);
                if (/^\d*$/.test(value)) {
                  formik.setFieldValue("booking_amount", value);
                }
              }}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Booking Amount"
              variant="standard"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography sx={{ fontSize: "13px", color: "#6B7280", mr: "2px" }}>
                      ₹
                    </Typography>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
            />
          </Grid>
          {/* <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="member_price"
              value={formik.values.member_price}
              onChange={(e) => {
                const value = e.target.value === "" ? 0 : Number(e.target.value);
                if (/^\d*$/.test(value)) {
                  formik.setFieldValue("member_price", value);
                }
              }}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Member Amount"
              variant="standard"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography sx={{ fontSize: "13px", color: "#6B7280", mr: "2px" }}>
                      ₹
                    </Typography>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
            />
          </Grid> */}
          {/* <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="special_price"
              value={formik.values.special_price}
              onChange={(e) => {
                const value = e.target.value === "" ? 0 : Number(e.target.value);
                if (/^\d*$/.test(value)) {
                  formik.setFieldValue("special_price", value);
                }
              }}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Special Amount"
              variant="standard"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography sx={{ fontSize: "13px", color: "#6B7280", mr: "2px" }}>
                      ₹
                    </Typography>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
            />
          </Grid> */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
            <SingleCheckbox
              xs={12}
              md={6}
              name="member_only"
              label="Member Only"
              onChange={(event) => handleIsMemberOnly(event)}
              onBlur={formik.handleBlur}
              checked={memberOnly}
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
            <SingleCheckbox
              xs={12}
              md={6}
              name="is_hide_total_bookings"
              label="Hide Total Bookings"
              onChange={(event) => handleTotalBooking(event)}
              onBlur={formik.handleBlur}
              checked={isHideBooking}
            />
          </Grid>
          {memberOnly && (
            <Grid item xs={12} md={12}>
              <SingleCheckbox
                xs={12}
                md={12}
                name="is_allow_guest_booking"
                label="Allow Guest Bookings"
                onChange={(event) => handleIsAllowGuestBooking(event)}
                onBlur={formik.handleBlur}
                checked={isAllowGuest}
              />
            </Grid>
          )}
          {isAllowGuest && (
            <>
              <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
                <MDInput
                  type="number"
                  name="guest_limit_for_booking"
                  value={formik.values.guest_limit_for_booking}
                  onChange={(e) => {
                    const value = e.target.value === "" ? 0 : Number(e.target.value);
                    formik.setFieldValue("guest_limit_for_booking", value);
                  }}
                  onBlur={formik.handleBlur}
                  sx={{ width: "100%" }}
                  label="Guest Limit For Booking"
                  variant="standard"
                />
              </Grid>
              <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
                <MDInput
                  type="number"
                  name="guest_price"
                  value={formik.values.guest_price}
                  onChange={(e) => {
                    const value = e.target.value === "" ? 0 : Number(e.target.value);
                    formik.setFieldValue("guest_price", value);
                  }}
                  onBlur={formik.handleBlur}
                  sx={{ width: "100%" }}
                  label="Guest Price"
                  variant="standard"
                />
              </Grid>
            </>
          )}

          <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
            <MDBox component="h2" sx={{ fontSize: "20px", fontWeight: "500" }}>
              Event Links
            </MDBox>
            <DraggableLinkForm
              handleRemoveRegistration={handleRemoveRegistration}
              formik={formik}
              handleRegistrationTitleChange={handleRegistrationTitleChange}
              handleRegistrationLinkChange={handleRegistrationLinkChange}
              handleReorder={handleReorder}
              handleButtonTextChange={handleButtonTextChange}
            />
          </Grid>
          <Grid item xs={12} md={12} mt={1} sx={{ display: "flex", justifyContent: "end" }}>
            <SubmitButton
              onClick={handleAddRegistrationLink}
              btnText={
                <>
                  <Iconify icon="solar:add-square-bold" />
                  Add Link
                </>
              }
            />
          </Grid>

          <Grid item xs={12} sx={{ paddingTop: "20px !important" }}>
            <MDBox component="h2" sx={{ fontSize: "20px", fontWeight: "500" }}>
              Advertisement
            </MDBox>
          </Grid>

          <Grid item xs={12} md={12} sx={{ paddingTop: "10px !important" }}>
            <MDSelectBox
              name="event_advertisements"
              defaultValue={advertisement ?? []}
              options={advertisementData ?? []}
              handleChange={(value) => handleAdvertisement(value)}
              label="Advertisement"
              width="100%"
              onBlur={formik.handleBlur}
              multiple={true}
            />
          </Grid>

          <Grid item xs={12} sx={{ paddingTop: "20px !important" }}>
            <MDBox component="h2" sx={{ fontSize: "20px", fontWeight: "500" }}>
              Social Media Links
            </MDBox>
          </Grid>

          {/* Instagram Link */}
          <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="instagram_link"
              value={formik.values.instagram_link}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Instagram Link"
              sx={{ width: "100%" }}
              variant="standard"
            />
          </Grid>

          {/* Facebook Link */}
          <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="facebook_link"
              value={formik.values.facebook_link}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Facebook Link"
              sx={{ width: "100%" }}
              variant="standard"
            />
          </Grid>

          {/* Whatsapp Link */}
          <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="whatsapp_link"
              value={formik.values.whatsapp_link}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Whatsapp Link"
              sx={{ width: "100%" }}
              variant="standard"
            />
          </Grid>

          {/* Popular */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "50px !important" }}>
            <MDSelectBox
              name="is_popular"
              defaultValue={popular}
              options={popularData}
              handleChange={(value) => hasPopular(value)}
              label="Popular"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
            />
          </Grid>

          {/* status */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "50px !important" }}>
            <MDSelectBox
              name="is_active"
              defaultValue={status}
              options={statusData}
              handleChange={(value) => handleStatusChange(value)}
              label="Status"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.is_active && formik.errors.is_active && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.is_active}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
            <SingleCheckbox
              xs={12}
              md={12}
              name="is_online_booking_available"
              label="This event is available for online booking"
              onChange={(event) => handleIsOnlineBook(event)}
              onBlur={formik.handleBlur}
              checked={isBookOnline}
            />
          </Grid>
        </Grid>

        <MDBox sx={{ width: "100%", textAlign: "center", marginTop: "40px" }}>
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
        </MDBox>
      </MDBox>
    </>
  );
};
EventForm.propTypes = {
  getEventList: PropTypes.func,
};

export default EventForm;
